import clevertap from "clevertap-web-sdk";
import ReactStars from "react-rating-stars-component";
import { useContext, useEffect, useState } from "react";
import { inBetweenDates } from "multi-date";
import { Tooltip } from "react-tooltip";
import { renderToString } from "react-dom/server";
import "react-tooltip/dist/react-tooltip.css";

// components
import PopUpDrawer from "components/UniversalURL/UniversalURLReviewHeader/NPS/PopUpDrawer";
import { AllMeals } from "../AllMeals";
import { MealPopUp } from "./MealPopup";

// assets
import { SvgBlankHeart } from "assets/icons/js/SvgBlankHeart.js";
import { SvgFilledHeart } from "assets/icons/js/SvgFilledHeart";
import { SvgRedExclamtion } from "assets/icons/js/SvgRedExclamtion";
import { SvgShare } from "assets/icons/js/SvgShare";
import { ReactComponent as MealsSvg } from "assets/meals.svg";
import { ReactComponent as NotMealsSvg } from "assets/meals_not.svg";
import { ReactComponent as IconSvg } from "assets/info.svg";
import { SvgPetFriendly } from "assets/icons/js/SvgPetFriendly";
import { ReactComponent as CallIcon } from "assets/icons/contactUs.svg";
import { ReactComponent as AQIIcon } from "assets/aqi.svg";

// helpers
import { AddingToCollection } from "helpers/addToCollection";
import getImg from "helpers/getCloudinaryImage";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";
import { useUser } from "customHooks/useUser";
import { useSearchQuery } from "customHooks/useQuery";

// context
import { ListingInterface } from "context/ListingData";

//scss
// import { ListingCouponUi } from "components/ListingNew/ListingNormal/ListingCouponUi";

import "./style.scss";
import { SvgVillType } from "assets/icons/js/SvgBedroomIcon";
import { SvgGuestIcon } from "assets/icons/js/SvgGuestIcon";
import { SvgBedroom } from "assets/icons/js/SvgBedroom";
import { SvgSparkle } from "assets/icons/js/SvgSparkle";
import { SvgFlames } from "assets/icons/js/SvgFlames";
import { ReactComponent as PdfLogo } from "assets/pdf.svg";
import { goAxiosInstance } from "helpers/axiosInstance";
import moment from "moment";
import { useQuery } from "react-query";
import { AskMeModal } from "components/Booking/AskHelp";
import { useTheme } from "components/ListingNew/ListingTheme";
import axios from "axios";

const ListingNameAddress = ({
	setShowLoginPopup,
	calError,
	reviewsRef,
	openSharePopup,
	dates,
	childrenData,
	adultsData,
	infantsData,
	roomsData,
	id,
	calculations,
}: any) => {
	// @ts-ignore
	const { data } = useContext(ListingInterface);
	// console.log(data?.data?.listing_list);

	const listingList = data?.data?.listing_list;
	const suitables_list = data?.data?.suitables_list;
	// console.log(listingList)
	const ratingList = data?.data?.rating_obj;
	const imageList = getImg({
		id: data?.data?.images_list[0],
		version: "",
	});

	const spotlight = data?.data?.sleeping_and_spotlist.spot_info;
	const self_catering_facility =
		data?.data?.sleeping_and_spotlist.spot_info.self_catering_facility !== " "
			? data?.data?.sleeping_and_spotlist.spot_info.self_catering_facility
			: "";

	const amen = data?.data?.amenities_list;

	const villSpecaility =
		data?.data?.sleeping_and_spotlist?.spot_info?.villa_speciality &&
		Object.keys(data?.data?.sleeping_and_spotlist?.spot_info?.villa_speciality)
			.length > 0
			? data?.data?.sleeping_and_spotlist?.spot_info?.villa_speciality?.long[0]
			: "";

	const name = listingList.title?.split("-")[0];

	const rating = ratingList.all_rating_obj;
	const additional = {
		type: listingList.TYPE_FLAG,
		bedrooms: listingList.num_similar_rooms,
		sleeps: listingList.max_capacity,
		capacity: listingList.capacity,
	};

	const [save, setSave] = useState(listingList?.in_collection);

	const visitsData = useQuery(["visits"], () => {
		return goAxiosInstance({
			url: `visits?id=${id}&date=${moment()
				.add(-1, "days")
				.format("YYYY-MM-DD")}`,
			method: "GET",
		});
	});

	const width = useMediaQuery();
	const breakpoint = 900;
	const isMobile = width < breakpoint;

	// check if the user exists
	const user = useUser();

	// rating
	const nanCheck =
		isNaN(rating.overall / ratingList.review) === true
			? 0
			: +(rating.overall / ratingList.review);

	// meals
	const meals = listingList?.meal_chargeable;
	const meals_optional =
		listingList?.meal_charges_adult === 0 &&
		listingList?.meal_charges_adult_allmeals === 0 &&
		listingList?.meal_charges_adult_allmeals_NV === 0 &&
		listingList?.meal_charges_adult_nv === 0 &&
		listingList?.meal_charges_children === 0 &&
		listingList?.meal_charges_children_allmeals === 0 &&
		listingList?.meal_charges_children_allmeals_nv === 0 &&
		listingList?.meal_charges_children_nv === 0;

	const HOMeals = Object.keys(amen).includes("25") && meals_optional;
	const petFirendly =
		Object.keys(amen).includes("14") || Object.keys(amen).includes("19");
	const meal_data = {
		vegPrice: listingList?.meal_charges_adult_allmeals,
		nonVegPrice: listingList?.meal_charges_adult_allmeals_NV,
		isJain:
			Object.keys(amen).includes("22") || Object.keys(amen).includes("66"),
		isNonVeg:
			Object.keys(amen).includes("65") ||
			Object.keys(amen).includes("66") ||
			listingList?.meal_charges_adult_nv !== 0 ||
			listingList?.meal_charges_adult_allmeals_NV !== 0 ||
			listingList?.meal_charges_children_nv !== 0,
		isVeg: true,
		breakFastAvailable: Object.values(data?.data?.amenities_list).includes(
			"Breakfast Included In Tariff",
		),
	};

	const [openMobileMeal, setOpenMobileMeal] = useState(false);
	const [openMobilePet, setOpenMobilePet] = useState(false);
	const [open, setOpen] = useState(false);

	const query = useSearchQuery();

	const [petData, setPetData] = useState<any>({});
	const getPetExpand = async () => {
		const res = await axios.get(
			"https://go.saffronstays.com/api/get-pet-expand?listingId=" +
				listingList?.id,
		);
		if (res.data.success) {
			setPetData(JSON.parse(res.data.data || {}));
		}
	};
	useEffect(() => {
		getPetExpand();
	}, []);

	useEffect(() => {
		//@ts-ignore
		let tw;
		if (window) {
			//@ts-ignore
			tw = window.addEventListener("click", (ele) => {
				//@ts-ignore
				if (ele?.target?.id === "meal-btn") {
					//@ts-ignore
					document.getElementById("Meals").scrollIntoView();

					setTimeout(() => {
						//@ts-ignore
						document.getElementById("Meals").style.animation =
							"hightligther 1s linear";
					}, 250);
					setTimeout(() => {
						//@ts-ignore
						document.getElementById("Meals").style.animation = "none";
					}, 1250);
					// clearTimeout(animationHighLight);
				}
			});
		}
		return () => {
			//@ts-ignore
			window.removeEventListener("click", tw);
		};
	}, []);

	const [openAskHelp, setOpenAskHelp] = useState(false);

	const theme = useTheme();
	const isMealDiscount = listingList?.is_meal_five;

	return (
		<>
			<AskMeModal
				open={openAskHelp}
				setOpen={setOpenAskHelp}
				data={{
					theme: theme,
					allowSelectLessRoom: true,
					LISTING_ID: listingList?.id,
					FROM_DATE:
						Object.keys(calculations).length > 0
							? calculations.FROM_DATE
							: "NA",
					TO_DATE:
						Object.keys(calculations).length > 0 ? calculations.TO_DATE : "NA",
					NO_OF_GUESTS:
						Object.keys(calculations).length > 0
							? calculations.NO_OF_GUESTS
							: listingList?.max_capacity,
					NO_OF_ROOMS:
						Object.keys(calculations).length > 0
							? calculations.NO_OF_ROOMS
							: listingList?.num_similar_rooms,
					TOTAL_AMOUNT_WITH_SERVICE:
						Object.keys(calculations).length > 0
							? calculations.TOTAL_AMOUNT_WITH_SERVICE
							: listingList?.per_night_charge,
					isListing: true,
					isVilla: additional.type === "MV",
					showLessRoom: listingList?.TYPE_FLAG === "EV",
				}}
			/>
			<AllMeals listingList={listingList} open={open} setOpen={setOpen} />
			<section className="listing__name-address">
				{isMobile && calError && (
					<div className="booking-box__error-mobile">
						<SvgRedExclamtion />
						<p className="text-xsm-light error">
							{calError === "rooms not avaiable for given dates" &&
								`This home is not available for the selected dates. Please change them to see availability.`}
							{calError === "minimum nights for this listing are 2" &&
								`Minimum nights for this listing are two. Please change the dates.`}
							{calError === "minimum nights for this listing are 3" &&
								`Minimum nights for this listing are three. Please change the dates.`}
							{![
								"rooms not avaiable for given dates",
								"minimum nights for this listing are 2",
								"minimum nights for this listing are 3",
							].includes(calError) && calError}
						</p>
					</div>
				)}
				<div
					className="rating"
					onClick={() => {
						if (reviewsRef && reviewsRef.current) {
							window.scrollTo({
								top: reviewsRef.current.offsetTop + 300,
								behavior: "smooth",
							});
						}
					}}
				>
					{rating.overall ? (
						<>
							<div
								className="text-xsm-bold"
								style={{ color: theme?.baseTextColor }}
							>
								{(rating.overall / ratingList.review).toFixed(1)}
							</div>
							<ReactStars
								size={18}
								value={nanCheck}
								activeColor="#FBA919"
								color="#DDDDDD"
								isHalf={true}
								edit={false}
							/>
							<a style={{ textDecoration: "none" }} href="#Reviews">
								{" "}
								<div
									className="text-xsm-light  villa_reviews"
									style={{ color: theme?.baseTextColor }}
								>
									{ratingList.review} reviews
								</div>
							</a>
						</>
					) : null}
				</div>
				{/* {isMobile && calError && (
					<div className="booking-box__error-mobile">
						<SvgRedExclamtion />
						<p className="text-xsm-light error">{calError}</p>
					</div>
				)} */}
				{/* calError &&
					(calError === "rooms not avaiable for given dates" ||
						calError === "minimum nights for this listing are 2" ||
						calError === "minimum nights for this listing are 3") && (
						<div className=" booking-box__error-mobile">
							<SvgRedExclamtion />
							{calError === "rooms not avaiable for given dates" && (
								<p className="text-xsm-light error">
									This home is not available for the selected dates. Please
									change them to see availability.
								</p>
							)}
							{calError === "minimum nights for this listing are 2" && (
								<p className="text-xsm-light error">
									Minimum nights for this listing are two. Please change the
									dates.
								</p>
							)}
							{calError === "minimum nights for this listing are 3" && (
								<p className="text-xsm-light error">
									Minimum nights for this listing are three. Please change the
									dates.
								</p>
							)}
						</div>
					)} */}
				{!isMobile && (
					<div className="action-btns">
						<button
							aria-label="share"
							className="listing__button text-sm clr-black"
							onClick={() => {
								window.open(
									`https://api.whatsapp.com/send/?phone=918291050012&text=Send%20me%20a%20PDF%20for%20${
										listingList?.file_reference?.split("-")[0]
									}--${listingList?.id}`,
								);
							}}
						>
							<PdfLogo
								style={
									{
										// filter: "grayscale(1)",
									}
								}
							/>
						</button>
						<button
							aria-label="share"
							className="listing__button text-sm clr-black"
							onClick={() => {
								clevertap.event.push("share_btn_listing_page", {
									listing_id: listingList.ID,
									listing_name: name,
									timestamp: new Date(),
								});
								openSharePopup();
							}}
						>
							<SvgShare fill={theme?.iconColor} />
						</button>
						<button
							aria-label="save"
							type="button"
							className="listing__button-save text-sm clr-black"
							onClick={() => {
								clevertap.event.push("shortlisted_villa", {
									villaName: listingList.file_reference,
									listingId: listingList.id,
									url: window.location.href,
									img: imageList,
									high_demand_message:
										visitsData?.data?.data?.data?.VALUE >= 50 &&
										`${visitsData?.data?.data?.data?.VALUE} Travelers saw this property in the last few hours`,
								});
								clevertap.event.push("addtocollection_btn_listing_page", {
									listing_id: listingList.id,
									listing_name: name,
									timestamp: new Date(),
									no_of_bedrooms: additional.bedrooms,
									no_of_guests: additional.sleeps,
									checkin_date: query.get("checkin"),
									checkout_date: query.get("checkout"),
									home_state: listingList.state,
									image_url: imageList,
									days_left_till_booking: `${parseInt(
										inBetweenDates(Date.now(), query.get("checkin")),
									)}`,
									total_payable: calculations.final_price,
								});
								if (!user) {
									setShowLoginPopup(true);
								}
								if (user) {
									setSave((prev: any) => !prev);
									AddingToCollection(listingList?.id, save);
								}
							}}
						>
							{!save ? (
								<span>
									<SvgBlankHeart stroke={theme?.iconColor} />
								</span>
							) : (
								<span>
									<SvgFilledHeart />
								</span>
							)}
						</button>
					</div>
				)}
			</section>

			<div className="listing__name-address-details">
				<span
					className="listing__name-tags"
					id="villa-tooltip1"
					style={{ background: theme?.nameTag?.background }}
				>
					{listingList?.TYPE_FLAG === "EV" && !suitables_list[84] && (
						<Tooltip
							delayHide={100}
							events={["hover"]}
							className="villa-popup1"
							anchorId="villa-tooltip1"
							style={{
								backgroundColor: theme?.nameTag?.popUpBackground,
								pointerEvents: "auto",
								border: "1px solid #F4F7FE",
								opacity: 1,
								boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.15)",
								padding: "20px",
								zIndex: "100",
								color: theme?.nameTag?.popUpTextColor,
							}}
						>
							<span className="ev-popup">
								We encourage you to book all rooms within the property for a
								better experience.
								<br /> Still, in case you wish to book a limited number of
								rooms,
								<br />
								please contact us <a href="tel:08069160000">
									08069160000
								</a> or{" "}
								<a href="mailto:book@saffronstays.com">book@saffronstays.com</a>
								.
							</span>
						</Tooltip>
					)}

					<SvgVillType
						fill={theme.name !== "NEXT" ? theme?.iconColor : "#666666"}
					/>
					<p style={{ color: theme?.baseTextColor }}>
						{suitables_list[84]
							? "Luxury Apartment"
							: additional.type === "MV"
							? "Separate Villas"
							: additional.type === "SR"
							? "Single Room"
							: additional.type === "MR"
							? "Separate Rooms"
							: additional.type === "EV-MR"
							? "Entire Home"
							: additional.type === "CL"
							? "Group of Villas"
							: additional.type === "EV"
							? "Entire Home"
							: ""}
					</p>
					{listingList?.TYPE_FLAG === "EV" && !suitables_list[84] && (
						<IconSvg
							style={{ filter: theme?.name === "xseries" ? "invert(1)" : "" }}
						/>
					)}
				</span>
				<span
					className="listing__name-tags"
					style={{
						background: theme?.nameTag?.background,
					}}
				>
					<SvgGuestIcon
						stroke={theme.name !== "NEXT" ? theme?.iconColor : "#666666"}
					/>
					<p
						style={{ color: theme?.baseTextColor }}
					>{`${additional.sleeps} Guests`}</p>
				</span>
				<span
					className="listing__name-tags"
					id="villa-tooltip2"
					style={{
						cursor: "pointer",
						background: theme?.nameTag?.background,
					}}
				>
					<SvgBedroom
						fill={theme.name !== "NEXT" ? theme?.iconColor : "#666666"}
					/>
					<p style={{ color: theme?.baseTextColor }}>
						{`${additional.bedrooms} ${
							additional.type === "MV" ? "Villa" : "Bedrooms"
						}`}
					</p>{" "}
					{listingList?.TYPE_FLAG === "EV" && !suitables_list[84] && (
						<IconSvg
							style={{ filter: theme?.name === "xseries" ? "invert(1)" : "" }}
						/>
					)}
					{listingList?.TYPE_FLAG === "EV" && !suitables_list[84] && (
						<Tooltip
							delayHide={100}
							events={["hover"]}
							className="villa-popup2"
							anchorId="villa-tooltip2"
							style={{
								backgroundColor: theme?.nameTag?.popUpBackground,
								pointerEvents: "auto",
								border: "1px solid #F4F7FE",
								opacity: 1,
								boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.15)",
								padding: "20px",
								zIndex: "100",
								color: theme?.nameTag?.popUpTextColor,
							}}
						>
							<span className="ev-popup">
								We encourage you to book all rooms within the property for a
								better experience. <br />
								In case you wish to book fewer rooms,{" "}
								<button
									style={{
										color: theme?.textButtonColor,
										background: "none",
										border: "none",
										outline: "none",
										textDecoration: "underline",
									}}
									onClick={(e) => {
										e.stopPropagation();
										setOpenAskHelp(true);
									}}
								>
									Click here
								</button>
							</span>
						</Tooltip>
					)}
				</span>

				{self_catering_facility || !HOMeals ? (
					<>
						{!self_catering_facility
							? MealPopBox(
									openMobileMeal,
									setOpenMobileMeal,
									HOMeals,
									meal_data,
									meals,
									meals_optional,
									isMobile,
									listingList,
									isMealDiscount,
							  )
							: self_catering_facility
									?.split(",")
									.filter((ele: any) => ele !== "")
									?.map((ele: string) => (
										<span
											style={{
												cursor: "pointer",
												background: theme?.nameTag?.background,
											}}
											className="listing__name-tags"
											data-tooltip-html={"Charges might apply"}
											id={
												["Fully equipped kitchen for Guest use"].includes(ele)
													? "tc-tooltip"
													: ""
											}
										>
											{ele.toLowerCase() === "self catered" && (
												<NotMealsSvg style={{ stroke: theme?.iconColor }} />
											)}
											{["Fully equipped kitchen for Guest use"].includes(
												ele,
											) && <MealsSvg style={{ stroke: theme?.iconColor }} />}
											{["Order in Food", "Chef on Call"].includes(ele) && (
												<CallIcon style={{ stroke: theme?.iconColor }} />
											)}
											<p style={{ color: theme?.baseTextColor }}>{ele}</p>
											{["Fully equipped kitchen for Guest use"].includes(
												ele,
											) && (
												<>
													<Tooltip
														delayHide={100}
														events={["hover"]}
														className="meal-popup"
														anchorId="tc-tooltip"
														style={{
															backgroundColor: theme?.nameTag?.popUpBackground,
															pointerEvents: "auto",
															border: "1px solid #F4F7FE",
															opacity: 1,
															boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.15)",
															padding: "20px",
															zIndex: "100",
															color: theme?.nameTag?.popUpTextColor,
														}}
													/>{" "}
													<IconSvg
														style={{
															filter:
																theme?.name === "xseries" ? "invert(1)" : "",
														}}
													/>
												</>
											)}
										</span>
									))}
					</>
				) : (
					MealPopBox(
						openMobileMeal,
						setOpenMobileMeal,
						HOMeals,
						meal_data,
						meals,
						meals_optional,
						isMobile,
						listingList,
						isMealDiscount,
					)
				)}
				{petFirendly && (
					<span
						style={{
							cursor: "pointer",
							background: theme?.nameTag?.background,
						}}
						// onClick={() => {
						// 	if (isMobile) setOpenMobilePet(true);
						// }}
						onMouseEnter={() => setOpenMobilePet(true)}
						onMouseLeave={() => setOpenMobilePet(false)}
						className="listing__name-tags pet__friendly__tags"
						id="pet-tooltip"
					>
						{listingList &&
							listingList.pet_charges > 0 &&
							!Object.keys(amen).includes("14") && (
								<Tooltip
									delayHide={100}
									events={["hover"]}
									className="villa-popup1"
									anchorId="pet-tooltip"
									style={{
										backgroundColor: theme?.nameTag?.popUpBackground,
										pointerEvents: "auto",
										border: "1px solid #F4F7FE",
										opacity: 1,
										boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.15)",
										padding: "20px",
										zIndex: "100",
										color: theme?.nameTag?.popUpTextColor,
									}}
								>
									<span className="ev-popup">
										Cost: ₹{listingList.pet_charges}/pet
									</span>
									<div
										style={{
											marginTop: "20px",
										}}
									>
										{petData?.amenities?.map((ele: any) => {
											return (
												<ul
													style={{
														paddingLeft: "20px",
													}}
												>
													<li
														style={{
															textDecoration:
																ele?.status === "s" ? "line-through" : "",
														}}
													>
														{ele?.name}
													</li>
												</ul>
											);
										})}
									</div>
								</Tooltip>
							)}

						<SvgPetFriendly />
						<p style={{ color: theme?.baseTextColor }}>
							{Object.keys(amen).includes("14")
								? "100% Pet Friendly"
								: "Pet Friendly"}
						</p>
						<IconSvg
							style={{ filter: theme?.name === "xseries" ? "invert(1)" : "" }}
						/>
						{/* {Object.keys(amen).includes("14") && <IconSvg />} */}
						{openMobilePet && Object.keys(amen).includes("14") && (
							<div className="pet__friendly__cont">
								<p>Cost: ₹{listingList.pet_charges}/pet</p>
								<p>Pets allowed in pools as well</p>
								{/* <div style={{
										marginTop:"20px"
									}}>
									{
										petData?.amenities?.map((ele:any)=>{
											return(
												<ul style={{
													paddingLeft:"20px",

												}}>
													<li style={{
														textDecoration:ele?.status==="s"? "line-through":""
													}}>
														{ele?.name}
													</li>
												</ul>
											)
										})
									}
									</div> */}
							</div>
						)}
					</span>
				)}
			</div>
			{villSpecaility ? (
				<div className="villa__highlight">
					<SvgSparkle />
					<p>{villSpecaility}</p>
				</div>
			) : null}
			{/* <ListingCouponUi
				dates={dates}
				id={id}
				childrenData={childrenData}
				adultsData={adultsData}
				roomsData={roomsData}
				infantsData={infantsData}
			/> */}
			<div
				className="tab-wrapper"
				style={{ marginTop: "20px", marginBottom: "30px" }}
			>
				{theme?.name !== "xseries" &&
				visitsData?.data?.data?.data?.VALUE >= 50 ? (
					<div className="visits-container">
						<SvgFlames />
						<span>
							<p className="title">High Demand</p>
							<p className="sub-title">
								{visitsData?.data?.data?.data?.VALUE} Travellers seeing this
							</p>
						</span>
					</div>
				) : null}
				{/* {spotlight?.aqi
					? spotlight?.aqi < 75 && (
							<div className="visits-container aqi">
								<AQIIcon />
								<span>
									<p className="title">
										{spotlight?.aqi <= 25 && "Excellent AQI"}
										{spotlight?.aqi > 25 && "Good AQI"}
									</p>
									<p className="sub-title">
										{spotlight?.aqi} on{" "}
										{new Date().toDateString().split(" ").slice(1, 3).join(" ")}
									</p>
								</span>
							</div>
					  )
					: null} */}
				{/* {spotlight?.tempreture &&
					parseFloat(JSON.parse(spotlight?.tempreture)?.currentTemp) < 30 && (
						<div className="visits-container temp">
							<img src={JSON.parse(spotlight?.tempreture)?.icon} alt="" />
							<span>
								<p className="title">
									{JSON.parse(spotlight?.tempreture)?.text}
								</p>
								<p className="sub-title">
									{JSON.parse(spotlight?.tempreture)?.currentTemp}°C Temp
								</p>
							</span>
						</div>
					)} */}
			</div>
		</>
	);
};

export default ListingNameAddress;
function MealPopBox(
	openMobileMeal: boolean,
	setOpenMobileMeal: any,
	HOMeals: boolean,
	meal_data: {
		vegPrice: any;
		nonVegPrice: any;
		isJain: boolean;
		isNonVeg: boolean;
		isVeg: boolean;
		breakFastAvailable: boolean;
	},
	meals: any,
	meals_optional: boolean,
	isMobile: boolean,
	listingList: any,
	isDiscount: boolean,
) {
	const theme = useTheme();
	return (
		<>
			{/* @ts-ignore */}
			<PopUpDrawer
				open={openMobileMeal}
				setOpen={setOpenMobileMeal}
				className={`meal-popup-drawer ${
					theme?.name === "xseries" && "x-series-meal-popup"
				}`}
			>
				{HOMeals
					? MealPopUp(
							meal_data,
							3,
							"Meals can be added as an additional charge after you book",
							setOpenMobileMeal,
							listingList,
							isDiscount,
					  )
					: meals === "Y"
					? MealPopUp(
							meal_data,
							1,
							"Meals are included in your booking amount",
							setOpenMobileMeal,
							listingList,
							isDiscount,
					  )
					: meals_optional
					? MealPopUp(
							meal_data,
							3,
							"",
							setOpenMobileMeal,
							listingList,
							isDiscount,
					  )
					: MealPopUp(
							meal_data,
							2,
							"Meals can be added before and after you book",
							setOpenMobileMeal,
							listingList,
							isDiscount,
					  )}
			</PopUpDrawer>

			{/* @ts-ignore */}
			<span
				style={{
					cursor: "pointer",
					background: theme?.nameTag?.background,
				}}
				// id="meals-tooltip-1"
				onClick={() => {
					if (isMobile) setOpenMobileMeal(true);
					clevertap.event.push("viewMenu_btn_listing_page", {
						location: window.location.pathname.split("/")[2],
						timestamp: new Date(),
						villaId: listingList?.id,
						villaName: listingList?.file_reference,
						type: "Meal Options",
					});
				}}
				data-tooltip-html={renderToString(
					HOMeals
						? MealPopUp(
								meal_data,
								3,
								"Meals can be added as an additional charge after you book",
								setOpenMobileMeal,
								listingList,
								isDiscount,
						  )
						: meals === "Y"
						? MealPopUp(
								meal_data,
								1,
								"Meals are included in your booking amount",
								setOpenMobileMeal,
								listingList,
								isDiscount,
						  )
						: meals_optional
						? MealPopUp(
								meal_data,
								3,
								"",
								setOpenMobileMeal,
								listingList,
								isDiscount,
						  )
						: MealPopUp(
								meal_data,
								2,
								"Meals can be added before and after you book",
								setOpenMobileMeal,
								listingList,
								isDiscount,
						  ),
				)}
				className="listing__name-tags"
				id="meals-tooltip"
			>
				{!isMobile && (
					<>
						<Tooltip
							delayHide={100}
							events={["hover"]}
							className="meal-popup"
							anchorId="meals-tooltip"
							style={{
								backgroundColor: theme?.nameTag?.popUpBackground,
								pointerEvents: "auto",
								border: "1px solid #F4F7FE",
								opacity: 1,
								boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.15)",
								padding: "20px",
								zIndex: "100",
								color: theme?.nameTag?.popUpTextColor,
							}}
						/>
					</>
				)}
				{HOMeals ? (
					<MealsSvg />
				) : meals === "N" ? (
					meals_optional ? (
						<NotMealsSvg />
					) : (
						<MealsSvg />
					)
				) : (
					<MealsSvg />
				)}
				<p style={{ color: theme?.baseTextColor }}>
					{HOMeals
						? "Meals Available"
						: meals === "Y"
						? "Meals Included"
						: meals_optional
						? "Self Catered"
						: "Meals Available"}
				</p>
				<IconSvg
					style={{ filter: theme?.name === "xseries" ? "invert(1)" : "" }}
				/>
			</span>
		</>
	);
}
